import { User } from 'lucide-react';
import { useTranslation } from 'react-i18next';

type ContactCard = {
  name?: string;
  phones?: Array<{ phone?: string; type?: string }>;
  emails?: string[];
};

/** Renders shared contact cards (WhatsApp `contacts` message). */
export function ContactsCard({ contacts }: { contacts: ContactCard[] }) {
  const { t } = useTranslation('conversations');

  if (!contacts.length) return null;

  return (
    <div className="flex flex-col gap-1.5">
      {contacts.map((contact, index) => (
        <div
          key={`${contact.name ?? 'contact'}-${index}`}
          className="flex items-center gap-2.5 rounded-md bg-chat-bubble-overlay border border-chat-border-soft px-2.5 py-2"
        >
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-chat-accent/10 text-chat-accent-deep">
            {contact.name ? (
              <span className="text-sm font-semibold">{contact.name.charAt(0).toUpperCase()}</span>
            ) : (
              <User className="h-4 w-4" />
            )}
          </div>
          <div className="min-w-0">
            <p className="text-sm font-medium text-chat-text truncate">
              {contact.name || t('messageView.contactsCard.unknownName')}
            </p>
            {(contact.phones ?? [])
              .filter((phone) => phone.phone)
              .map((phone) => (
                <p key={phone.phone} className="text-xs text-chat-text-muted truncate">
                  {phone.phone}
                </p>
              ))}
            {(contact.emails ?? []).map((email) => (
              <p key={email} className="text-xs text-chat-text-muted truncate">
                {email}
              </p>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
